export default "__VITE_ASSET__051af5b7__"